import { Global, ThemeProvider } from "@emotion/react";
import * as React from "react";
import { SAVORY_THEME } from "../theme";
import type { SvyProviderProps } from "./SvyProvider.interface";
import { GlobalStyles } from "./SvyProvider.style";
import "remixicon/fonts/remixicon.css";

export const SvyProvider: React.FunctionComponent<SvyProviderProps> = ({ theme = SAVORY_THEME, children }) => {
    return (
        <ThemeProvider theme={theme}>
            <Global styles={GlobalStyles} /> {children}
        </ThemeProvider>
    );
};
